import React from "react";
import classnames from "classnames";

function Button(props) {
  const {
    id,
    className,
    type,
    small,
    light,
    href,
    onClick,
    children,
    ...rest
  } = props;

  const elementType = href ? "a" : "button";

  const classNames = classnames("button", className, {
    "brush-button": type === "brush",
    button__secondary: type === "secondary",
    "plain-button": type === "plain",
    small,
    light,
  });

  return React.createElement(
    elementType,
    {
      id,
      className: classNames,
      onClick,
      href,
      rel: href ? "noreferrer noopener" : undefined,
      target: href ? "_blank" : undefined,
      type: elementType === "button" ? "button" : undefined,
      ...rest,
    },
    children
  );
}

export default Button;
